export default __webpack_public_path__ + "static/media/Icon feather-download.63623708.svg";